module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500.woff2?020c97dc8e0463259c2f9df929bb0c69";